import * as React from 'react';
import { SVGProps } from 'react';

const IconArtBrushSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 8c-.35-.35-.936-.48-1.471-.255-.474.214-.705.583-.818 1.139-.169.828-.398 1.61-.711 2.116.957.069 2 0 3.092-1.061C4.54 9.504 4.54 8.539 4 8zm7-7c-.595-.594-4 2.5-5.5 4-.56.56-1.248 1.421-1.5 2 .522.119.9.52 1 1 .615-.328 1.444-.944 2-1.5C8.5 5 11.595 1.594 11 1z" />
  </svg>
);
export default IconArtBrushSizeXs;
